import React from 'react';

const NotFound = () => {
  return (
    <section>
      <h2>NotFound</h2>
    </section>
  );
};

export default NotFound;